class VideoBanner extends HTMLElement {
  constructor() {
    super();
    this.createObserver();
    // window.addEventListener('scroll', this.zoomEffect.bind(this));
    this.media = this.querySelector('.media');
    this.zoomOut = false;
    this.videos = [];
    this.isPlaying = true;
    this.isMuted = true;
    this.controlsInitialized = false;
  }


  zoomEffect() {
    const position = this.getBoundingClientRect();

    if (position.bottom < window.innerHeight && this.zoomOut === false) {
      this.media.classList.add('zoom-out');
      this.zoomedOut = true;
    } else if (position.bottom >= window.innerHeight && this.zoomedOut) {
      const media = this.querySelector('.media');
      media.classList.remove('zoom-out');
      this.zoomedOut = false;
    }
  }

  createObserver() {
    const options = {
      root: this.querySelector("body"),
      rootMargin: "0px",
      threshold: 0
    };
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;
      this.onIntersecting(entry.isIntersecting);
    }, options);
    const target = this;
    observer.observe(target);
  }

  onIntersecting(isIntersecting) {
    if (!isIntersecting) return;

    const deferredMedias = this.querySelectorAll("deferred-media");
    deferredMedias.forEach((deferredMedia) => {
      deferredMedia.loadContent();
      setTimeout(() => {
        // Récupérer toutes les vidéos après chargement
        this.videos = this.querySelectorAll('video');
        
        this.videos.forEach(video => {
          video.play();
        });

        // Initialiser les contrôles maintenant que les vidéos sont chargées
        if (!this.controlsInitialized) {
          this.initializeControls();
          this.controlsInitialized = true;
        }
        this.updatePlayPauseIcon();
        this.updateSoundIcon();
        this.updateSoundCta();
      }, 200);
    });
  }


  initializeControls() {
    const playPauseBtn = this.querySelector('.video-banner__play-pause');
    const soundToggleBtn = this.querySelector('.video-banner__sound-toggle');
    const soundCtaBtn = this.querySelector('.video-banner__sound-cta-button');

    if (playPauseBtn) {
      playPauseBtn.addEventListener('click', this.togglePlayPause.bind(this));
    }

    if (soundToggleBtn) {
      soundToggleBtn.addEventListener('click', this.toggleSound.bind(this));
    }

    if (soundCtaBtn) {
      soundCtaBtn.addEventListener('click', this.enableSound.bind(this));
    }

  }


  togglePlayPause() {
    if (this.videos.length === 0) return;
    
    this.videos.forEach(video => {
      if (this.isPlaying) {
        video.pause();
      } else {
        video.play();
      }
    });

    this.isPlaying = !this.isPlaying;
    this.updatePlayPauseIcon();
  }

  toggleSound() {
    if (this.videos.length === 0) return;

    this.isMuted = !this.isMuted;

    this.videos.forEach(video => {
      video.muted = this.isMuted;
      if (this.isMuted) {
        video.setAttribute('muted', '');
      } else {
        video.removeAttribute('muted');
      }
    });

    this.updateSoundIcon();
    this.updateSoundCta();
  }

  enableSound() {
    if (this.videos.length === 0) return;

    this.videos.forEach(video => {
      video.muted = false;
      video.removeAttribute('muted');
    });

    this.isMuted = false;
    this.updateSoundIcon();
    this.updateSoundCta();
  }

  updatePlayPauseIcon() {
    const playIcon = this.querySelector('.video-banner__play-icon');
    const pauseIcon = this.querySelector('.video-banner__pause-icon');

    if (playIcon && pauseIcon) {
      if (this.isPlaying) {
        playIcon.style.display = 'none';
        pauseIcon.style.display = 'block';
      } else {
        playIcon.style.display = 'block';
        pauseIcon.style.display = 'none';
      }
    }
  }

  updateSoundIcon() {
    const soundOffIcon = this.querySelector('.video-banner__sound-off-icon');
    const soundOnIcon = this.querySelector('.video-banner__sound-on-icon');

    if (soundOffIcon && soundOnIcon) {
      if (this.isMuted) {
        soundOffIcon.style.display = 'block';
        soundOnIcon.style.display = 'none';
      } else {
        soundOffIcon.style.display = 'none';
        soundOnIcon.style.display = 'block';
      }
    }
  }

  updateSoundCta() {
    const soundCta = this.querySelector('.video-banner__sound-cta');

    if (soundCta) {
      soundCta.style.display = this.isMuted ? 'block' : 'none';
    }
  }

}

if (!customElements.get('video-banner')) {
  customElements.define('video-banner', VideoBanner);
}